import { Link, useLocation } from "react-router-dom";

function NotFound(params) {
  const location = useLocation();

  const { from = "patient" } = location?.state ?? {};
  const getLink = (type) => {
    let url = "/";
    switch (type) {
      case "clinic":
        url += "clinic/";
        break;
      case "patient":
        url += "patient/";
    }
    return url;
  };
  const link = getLink(from);
  return (
    <div className=" bg-[#fff] min-h-screen w-full justify-center items-center flex ">
      <div className=" text-center">
        <img className="  mx-auto w-[155px]" src="/images/logo.png" />
        <span className=" text-[15vh]  font-semibold text-[#04225b] ">4O4</span>
        <br />
        <span className=" text-2xl font-medium">NOT FOUND</span>
        <br />
        <div className=" text-xl mt-3">
          {" "}
          Sorry, but the page that you requested doesn't exist.
        </div>
        <br />
        <div className=" mt-5">
          <Link
            to={link}
            className=" bg-[#0188fc] hover:bg-[#076ec7] text-white p-3 px-5 rounded-lg cursor-pointer"
          >
            Continue to Our Home Page
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
